import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';


@Injectable()
export class OperationService {

  constructor(
              private http: HttpClient, 
              private global: GlobalDataService
             ) { }

  issueOperation(data: any){
      return this.http.post(this.global.httpUrl+'operations', data);
  }

  getOperation(page: number = 0) {
      let url = "";
      if(page){
        url = "?page="+page;
      }
        return this.http.get(this.global.httpUrl+'operations'+url);
  }

  getOperationById(id: string) {
        return this.http.get(this.global.httpUrl+'operations/'+id);
  }

  getOperationByFilter(filter: any[],page:number = 0) {
      let url = "";
      if(page){
        url = "page="+page + "&";
      }
      if(filter){
        for (var item of filter) {
          url += item.name + "=" + item.value + "&";
       }
      }
      
      url = url.substring(0,url.length-1);
  
      return this.http.get(this.global.httpUrl + "operations?" + url);
   }

  cancelOperation(data: any){
      return this.http.post(this.global.httpUrl+"operations/apply-status-canceled", data);
      
  }    

  getOperationItemsById(id: any){
      return this.http.get(this.global.httpUrl+"operations/items?operation_id="+id);
  }

  createOperationInvoice(invoice_number: any){
  	 // let data={'from_store_id' : this.global.user.stores[0].id,'operation_type_id' : 1,'invoice_number' : invoice_number};  
       let data = {};
        return this.http.post(this.global.httpUrl+"operations-cart", data); 
  }

  searchProductByAttribut(attributes: {}){
        return this.http.get(this.global.httpUrl+"product-storage?name="+attributes['name']);
  }

  addToOperationCartService(data: any){
        return this.http.post(this.global.httpUrl+"operations-cart/items", data);
  }

  


  deleteOperationInvoice(id: any){
        return this.http.delete(this.global.httpUrl+"operations-cart/"+id); 
  } 

  deleteOperationItemService(id: any){
        return this.http.delete(this.global.httpUrl+"operations-cart/items/"+id);
  }


  issueOperationInvoiceService(id: any,data: any){
        return this.http.post(this.global.httpUrl+"operations-cart/"+id+'/move', data);
  } 
}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/operations/operation.service.ts